import { memo, useCallback } from 'react';
import { columnsWidth } from '../../constants';
import { OrderHistoryDetailsCell } from './OrderHistoryDetailsCell';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { ORDER_STATUS } from 'src/constants/order';
import { SCREENS } from 'src/constants/screens';
import { localeStore } from 'src/mobx/localesStore';
import { orderColorByStatus, OrdersHistoryTableColumns, TOrder } from 'src/mobx/ordersHistoryStore/types';
import { history } from 'src/services/history';
import { formatDate } from 'src/utils/helpers';
import Icon from 'src/view/components/Controls/Icon/Icon';
import './styles.scss';

interface OrdersHistoryRowProps {
  order: TOrder;
}

const OrderStatusCell = ({ status }: { status: ORDER_STATUS }) => (
  <div className="d-flex flex-row align-items-center">
    <Icon name={Icons.Circle} size={24} color={orderColorByStatus[status]} />
    {localeStore.t(`${status}_status`)}
  </div>
);

const OrderHistoryRow = ({ order }: OrdersHistoryRowProps) => {
  const handleRowClick = useCallback(() => {
    history.push(SCREENS.HISTORY_ORDER_VIEW(order.id));
  }, [order.id]);

  return (
    <div className="orders-history_row" onClick={handleRowClick}>
      <div className={`text-preset__list-row orders-history_cell w-${columnsWidth[OrdersHistoryTableColumns.OrderID]}`}>{order.orderKey}</div>
      <div className={`text-preset__list-row orders-history_cell w-${columnsWidth[OrdersHistoryTableColumns.BranchName]}`}>{order.branchName}</div>
      <div className={`text-preset__list-row orders-history_cell w-${columnsWidth[OrdersHistoryTableColumns.CustomerPhone]}`}>
        {order.customerPhone}
      </div>
      <div className={`text-preset__list-row orders-history_cell w-${columnsWidth[OrdersHistoryTableColumns.Status]}`}>
        <OrderStatusCell status={order.status} />
      </div>
      <div className={`text-preset__list-row orders-history_cell w-${columnsWidth[OrdersHistoryTableColumns.CreatedAt]}`}>
        {formatDate(order.createdAt, {})}
      </div>
      <div className={`text-preset__list-row orders-history_cell w-${columnsWidth[OrdersHistoryTableColumns.Details]}`}>
        <OrderHistoryDetailsCell order={order} />
      </div>
      <div className={`text-preset__list-row orders-history_cell w-${columnsWidth[OrdersHistoryTableColumns.TotalPrice]}`}>{order.totalPrice}</div>
    </div>
  );
};

export default memo(OrderHistoryRow);
